import { render, staticRenderFns } from "./CMS_Pages.vue?vue&type=template&id=21b8229f&"
import script from "./CMS_Pages.vue?vue&type=script&lang=js&"
export * from "./CMS_Pages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports